(function () {
  const root = document.querySelector('.index-template main .fhp');
  if (!root) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  root.querySelectorAll('img.fhp-img').forEach((img) => {
    const done = () => img.classList.add('is-loaded');
    if (img.complete && img.naturalWidth > 0) done();
    else {
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    }
  });

  const parentTestiRoot = root.querySelector('[data-fhp-parent-testi]');
  if (parentTestiRoot) {
    const viewport = parentTestiRoot.querySelector('.testi-carousel__viewport');
    const track = parentTestiRoot.querySelector('.testi-carousel__track');
    const slideEls = track ? Array.from(track.children) : [];
    const slides = slideEls.length;
    const dotsWrap = parentTestiRoot.querySelector('[data-fhp-parent-dots]');
    let page = 0;
    let parentTimer = null;
    let parentPaused = false;

    const renderParent = () => {
      if (!track || !viewport || slides === 0) return;
      if (page >= slides) page = 0;
      if (page < 0) page = slides - 1;
      const offset = viewport.offsetWidth * page;
      track.style.transform = 'translate3d(-' + offset + 'px,0,0)';
      dotsWrap?.querySelectorAll('button').forEach((d, i) => {
        d.classList.toggle('is-active', i === page);
      });
    };

    const buildParentDots = () => {
      if (!dotsWrap || slides <= 1) {
        if (dotsWrap) dotsWrap.innerHTML = '';
        return;
      }
      dotsWrap.innerHTML = '';
      for (let i = 0; i < slides; i += 1) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = i === page ? 'is-active' : '';
        b.setAttribute('aria-label', 'Show testimonial ' + (i + 1));
        b.addEventListener('click', () => {
          page = i;
          renderParent();
          restartParentAutoplay();
        });
        dotsWrap.appendChild(b);
      }
    };

    const stopParentAutoplay = () => {
      parentPaused = true;
      if (parentTimer) window.clearInterval(parentTimer);
      parentTimer = null;
    };

    const startParentAutoplay = () => {
      if (reduced || slides <= 1 || parentPaused) return;
      if (parentTimer) window.clearInterval(parentTimer);
      parentTimer = window.setInterval(() => {
        page = (page + 1) % slides;
        renderParent();
      }, 3000);
    };

    const restartParentAutoplay = () => {
      parentPaused = false;
      stopParentAutoplay();
      startParentAutoplay();
    };

    buildParentDots();
    renderParent();

    if (!reduced && slides > 1) {
      parentTestiRoot.addEventListener('mouseenter', stopParentAutoplay);
      parentTestiRoot.addEventListener('mouseleave', restartParentAutoplay);
      parentTestiRoot.addEventListener('focusin', stopParentAutoplay);
      parentTestiRoot.addEventListener('focusout', restartParentAutoplay);
      parentTestiRoot.addEventListener(
        'touchstart',
        () => {
          stopParentAutoplay();
        },
        { passive: true }
      );
      parentTestiRoot.addEventListener('touchend', restartParentAutoplay, { passive: true });
      window.addEventListener('resize', renderParent);
      startParentAutoplay();
    }
  }

  const reviewsRoot = root.querySelector('[data-fhp-reviews]');
  if (reviewsRoot) {
    const track = reviewsRoot.querySelector('.fhp-reviews__track');
    const slides = track ? track.children.length : 0;
    const dotsWrap = root.querySelector('[data-fhp-reviews-dots]');
    const prevBtn = root.querySelector('[data-fhp-reviews-prev]');
    const nextBtn = root.querySelector('[data-fhp-reviews-next]');
    let perView = 3;
    let page = 0;

    const calcPerView = () => {
      if (window.innerWidth <= 760) perView = 1;
      else if (window.innerWidth <= 1100) perView = 2;
      else perView = 3;
    };

    const pages = () => Math.max(1, Math.ceil(slides / perView));

    const buildDots = () => {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (let i = 0; i < pages(); i += 1) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fhp-reviews__dot' + (i === page ? ' is-active' : '');
        b.setAttribute('aria-label', 'Go to review set ' + (i + 1));
        b.addEventListener('click', () => {
          page = i;
          render();
        });
        dotsWrap.appendChild(b);
      }
    };

    const render = () => {
      if (!track) return;
      if (page > pages() - 1) page = pages() - 1;
      if (page < 0) page = 0;
      track.style.transform = 'translateX(-' + page * 100 + '%)';
      dotsWrap?.querySelectorAll('.fhp-reviews__dot').forEach((d, i) => {
        d.classList.toggle('is-active', i === page);
      });
      if (prevBtn) prevBtn.disabled = pages() <= 1;
      if (nextBtn) nextBtn.disabled = pages() <= 1;
    };

    prevBtn?.addEventListener('click', () => {
      page = (page - 1 + pages()) % pages();
      render();
    });

    nextBtn?.addEventListener('click', () => {
      page = (page + 1) % pages();
      render();
    });

    const setup = () => {
      calcPerView();
      buildDots();
      render();
    };

    window.addEventListener('resize', () => {
      const old = perView;
      calcPerView();
      if (old !== perView) {
        page = 0;
        buildDots();
      }
      render();
    });

    setup();

    if (!reduced) {
      let timer;
      const start = () => {
        timer = window.setInterval(() => {
          page = (page + 1) % pages();
          render();
        }, 7000);
      };
      const stop = () => {
        if (timer) window.clearInterval(timer);
      };
      reviewsRoot.addEventListener('mouseenter', stop);
      reviewsRoot.addEventListener('mouseleave', start);
      reviewsRoot.addEventListener('focusin', stop);
      reviewsRoot.addEventListener('focusout', start);
      start();
    }
  }

  const items = root.querySelectorAll('[data-reveal]');
  root.classList.add('js-ready');

  if (reduced || !('IntersectionObserver' in window)) {
    items.forEach((el) => {
      el.classList.add('in');
      el.classList.remove('fhp-pending');
    });
    return;
  }

  items.forEach((el) => el.classList.add('fhp-pending'));

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        e.target.classList.remove('fhp-pending');
        io.unobserve(e.target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );
  items.forEach((el) => io.observe(el));
})();
